export default [
  { title: 'Food', value: 'food' },
  { title: 'Drink', value: 'drink' },
  { title: 'Brunch', value: 'brunch' },
  { title: 'Dinner', value: 'dinner' },
  { title: 'Breakfast', value: 'breakfast' },
  { title: 'Supper', value: 'supper' },
  { title: 'Tea', value: 'tea' },
  {
    title: 'Super long menu name for testing purposes only',
    value: 'long-menu',
  },
  { title: 'Superlongwithnospaces/beer', value: 'long-no-space-menu' },
];
